export const DEFAULT_CURRENCY_MINOR_UNIT = 2;

export const normalizeCurrencyMinorUnit = (value) => {
    // Keep configured precision within Number.prototype.toFixed's supported range.
    return Number.isInteger(value) && value >= 0 && value <= 100
        ? value
        : DEFAULT_CURRENCY_MINOR_UNIT;
};

export const formatAmountWithCurrency = (amount, currency, sign = '') => {
    if (!currency) return `${sign}${amount}`;
    return `${currency} ${sign.trim()}${amount}`;
};
